import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';

const RE_VALID_FORMAT = /^\d+:\d\d:\d\d$/;

const int = (value) => fromAnyToInteger(fromAnyToTrimmed(value));
const isSexagesimal = (value) => Number.isSafeInteger(value) && value >= 0 && value < 60;

const determineHoursLaterForNcob = (interval) => {
  const stringifiedInterval = fromAnyToTrimmed(interval);

  if (!stringifiedInterval) return NaN;
  if (!stringifiedInterval.match(RE_VALID_FORMAT)) return NaN;

  const [hoursString, minutesString, secondsString] = stringifiedInterval.split(':');

  const hours = int(hoursString);

  const minutes = int(minutesString);
  const seconds = int(secondsString);

  if (minutes === 0 && seconds === 0) return hours;

  if (!isSexagesimal(minutes)) return NaN;
  if (!isSexagesimal(seconds)) return NaN;

  return hours + 1;
};

export default determineHoursLaterForNcob;
